//core
import React, { useState } from "react";
import arePropsEqual from "react-fast-compare";
import { useTranslation } from "react-i18next";
import { UndoOutlined } from "@mui/icons-material";

//components
import ActionIconButton from "../../../../../UI/Buttons/ActionIconButton";
import MuiModal from "../../../../../UI/MuiModal";
// import ReturnPlayerModal from "../ReturnPlayerModal"; ignore for now

export interface ITableActions {
  id: number;
  data: any;
}

const TableActions: React.FC<ITableActions> = ({ data }) => {
  const { t } = useTranslation();
  const [showRestoreModal, setShowRestoreModal] = useState(false);

  const canRestoreRow = data?.is_player_statistics_restorable === true;

  const handleToggleRestoreModal = (state: boolean) => {
    setShowRestoreModal(state);
  };

  const handleClickRestore = () => canRestoreRow && setShowRestoreModal(true);

  return (
    <>
      <ActionIconButton
        text={t(
          canRestoreRow
            ? "admin.reports.full_report.actions.restore_player_statistics"
            : "admin.reports.full_report.actions.restore_player_statistics_unavailable"
        )}
        icon={<UndoOutlined fontSize="small" color={canRestoreRow ? "primary" : "disabled"} />}
        onClick={handleClickRestore}
      />

      <MuiModal
        width={520}
        open={showRestoreModal}
        closeOnOutside={false}
        setToggleModal={handleToggleRestoreModal}
      >
        <></>
        {/* <ReturnPlayerModal
          ftdDate={"2025-10-12"}
        /> ignore for now */}
      </MuiModal>
    </>
  );
};

export default React.memo(TableActions, arePropsEqual);
